import '../styles/password.scss'
import { Main } from "../components/layout/Main"
import { BreadcrumbType } from "../types/types"
import { Row, Col, Image, Space, Table, TableColumnsType, Typography, Button } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import api from '../services/api'
import { toast } from 'react-toastify'
import { useEffect, useState } from 'react'
import { ModalAddPicture } from '../components/objects/ModalAddPicture'

const items: BreadcrumbType[] = [
    {
        title: 'Home'
    },
    {
        title: 'Usuário'
    },
    {
        title: 'Minhas Fotos',
    },
]

type PictureType = {
    sequencia: string
    arquivo: string
    id: string
}

export function Picture() {
    const [data, setData] = useState<PictureType[]>([])
    const [isModalPaymentOpen, setIsModalPaymentOpen] = useState(false)

    async function changeDelete(item: string) {
        try {
            const response = await api.post('picture/delete', new URLSearchParams({
                id: item
            }))
            if (response.status === 200){
                toast.success(response.data.msg)
                loadData()
            }
            else
                toast.error('Erro ao Excluir a foto')
        } catch (error) {
            toast.error('Erro ao carregar dados do usuário: ' + error)
        }
    }

    function changeAdd() {
        setIsModalPaymentOpen(true)
    }

    async function loadData() {
        try {
            const response = await api.get('me/myPictures')
            setData(response.data.pictures)
        } catch (error) {
            toast.error('Erro ao carregar dados do usuário: ' + error)
        }
    }

    useEffect(() => {
        loadData()
    }, [isModalPaymentOpen])

    return (
        <Main itemBreadcrumb={items}>
            <ModalAddPicture handleOk={() => { setIsModalPaymentOpen(false) }} isModalOpen={isModalPaymentOpen} setIsModalOpen={setIsModalPaymentOpen} />
            <div className='content-invoice'>
                <Space direction="vertical" >
                    <Typography.Title level={4}>
                        Minhas Fotos
                    </Typography.Title>
                </Space>
                <div className='content-home-button'>
                    <Button type="primary" style={{ marginTop: '10px' }} onClick={() => changeAdd()}>
                        Adicionar Foto
                    </Button>
                </div>
                <Row gutter={[16, 16]}>
                    {data.map(({ arquivo, sequencia, id }) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={sequencia}>
                            <Image
                                src={arquivo}
                                alt={`Foto ${sequencia}`}
                                style={{ borderRadius: '8px' }}
                            />
                            <Button type="primary" style={{ marginTop: '10px' }} onClick={() => changeDelete(id)}>
                                Excluir
                            </Button>
                        </Col>
                    ))}
                </Row>
            </div>
        </Main>
    )
}